export const stringToDate = (stringDate: string) => {
  // NOTE: These string replacements stop new Date () from converting the datetime into user's timezone, we want to keep the datetime identical to what the endpoint sends us as they handle all of the timezone conversions
  return new Date(stringDate.replace(/-/g, "/").replace(/T.+/, ""));
};
